module.exports = __webpack_public_path__ + "img/2003.ba8f3d2d.jpg";